import { render, staticRenderFns } from "./path.vue?vue&type=template&id=aebafc06&scoped=true"
import script from "./path.vue?vue&type=script&lang=js"
export * from "./path.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebafc06",
  null
  
)

export default component.exports